module.exports = __webpack_public_path__ + "static/render2-84b6f1e538189a7844d99c22332200a5.png";